/**
 * Request Access Page
 *
 * Displayed when users try to access the platform without an invitation.
 * Provides information about the invitation-only nature of the platform.
 */

import { Mail01, Shield01, Users01 } from '@untitled-ui/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import AuthLayout from '@/components/auth/auth-layout';
import {
  AUTH_BUTTON_CLASS,
  AUTH_DESCRIPTION_CLASS,
  AUTH_HEADING_CLASS,
} from '@/components/auth/auth-styles';

const RequestAccess = () => {
  const { t } = useTranslation('auth');

  return (
    <AuthLayout>
      <div className="flex flex-col gap-6">
        <div>
          <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-landing-fg/5">
            <Shield01 className="size-6 text-landing-fg/60" />
          </div>
          <h1 className={AUTH_HEADING_CLASS}>{t('requestAccess.heading')}</h1>
          <p className={AUTH_DESCRIPTION_CLASS}>{t('requestAccess.description')}</p>
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex gap-3">
            <Users01 className="mt-0.5 size-5 shrink-0 text-landing-fg/30" />
            <div className="flex flex-col gap-1">
              <p className="text-sm leading-none font-medium text-landing-fg">
                {t('requestAccess.membersTitle')}
              </p>
              <p className="text-xs leading-[1.5] text-landing-fg/45">
                {t('requestAccess.membersBody')}
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            <Mail01 className="mt-0.5 size-5 shrink-0 text-landing-fg/30" />
            <div className="flex flex-col gap-1">
              <p className="text-sm leading-none font-medium text-landing-fg">
                {t('requestAccess.haveInvitationTitle')}
              </p>
              <p className="text-xs leading-[1.5] text-landing-fg/45">
                {t('requestAccess.haveInvitationBody')}
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2.5 border-t border-landing-fg/8 pt-5">
          <Link
            className={`inline-flex items-center justify-center whitespace-nowrap ${AUTH_BUTTON_CLASS}`}
            to="/auth/login"
          >
            {t('requestAccess.backToLogin')}
          </Link>
          <a
            className="inline-flex h-11 w-full items-center justify-center rounded-full border border-landing-fg/10 text-sm font-medium whitespace-nowrap text-landing-fg transition-colors hover:bg-landing-fg/5"
            href="mailto:support@publicpulse.com"
          >
            {t('requestAccess.contactSupport')}
          </a>
        </div>
      </div>
    </AuthLayout>
  );
};

export default RequestAccess;
